import React, { useContext } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { IoMicSharp, IoGrid, IoChatboxEllipses } from 'react-icons/io5';
import { IoMdVideocam } from 'react-icons/io';
import { MdScreenShare, MdBackHand, MdMoreVert } from 'react-icons/md';
import { FaSmile } from 'react-icons/fa';
import { BsPeopleFill } from 'react-icons/bs';
import { LanguageContext } from '../../../../../../../../libs/Context';

const IconLabel = ({ icon, label }) => (
	<Grid item sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', px: 2 }}>
		{icon}
		<Typography variant='body2' sx={{ color: 'white', textAlign: 'center' }}>
			{label}
		</Typography>
	</Grid>
);

const ControlPanel = (props) =>
{
	const { secondaryColor } = props;
	const language = useContext(LanguageContext);

	return (
		<Grid
			container
			sx={{
				backgroundColor : secondaryColor || '#05000054',
				display         : 'flex',
				alignItems      : 'center',
				justifyContent  : 'space-between',
				height          : 'var(--pixel64)',
				px              : 2,
				overflowX       : 'auto',
				whiteSpace      : 'nowrap',
				flexWrap        : 'nowrap'
				// Prevent line breaks
			}}
		>
			{/* Left Icons Group */}
			<Grid item flexDirection='row' display='flex' alignItems='center'>
				<IconLabel icon={<IoMicSharp fontSize='var(--pixel24)' color='var(--whiteColor)' />} label='Mic on' />
				<IconLabel icon={<IoMdVideocam fontSize='var(--pixel24)' color='var(--whiteColor)' />} label='Video on' />
				<IconLabel icon={<MdScreenShare fontSize='var(--pixel24)' color='var(--whiteColor)' />} label='Screen share' />
			</Grid>

			{/* Center Icons Group */}
			<Grid item flexDirection='row' display='flex' alignItems='center'>
				<Box sx={{ px: 2 }}>
					<IoGrid fontSize='var(--pixel24)' className='whiteTxt pointer' />
				</Box>
				<Box sx={{ px: 2 }}>
					<MdBackHand fontSize='var(--pixel24)' className='whiteTxt pointer' />
				</Box>
				<Box sx={{ px: 2 }}>
					<FaSmile fontSize='var(--pixel24)' className='whiteTxt pointer' />
				</Box>
				<Box sx={{ px: 2 }}>
					<MdMoreVert fontSize='var(--pixel24)' className='whiteTxt pointer' />
				</Box>
			</Grid>

			{/* Right Icons Group */}
			<Grid item flexDirection='row' display='flex' alignItems='center'>
				<IconLabel icon={<BsPeopleFill fontSize='var(--pixel24)' color='var(--whiteColor)' />} label='Participants' />
				<IconLabel icon={<IoChatboxEllipses fontSize='var(--pixel24)' color='var(--whiteColor)' />} label='Chat' />
				<IconLabel
					icon={<Box component='img' src='/images/icons/endMeetingIcon.svg' sx={{ height: 'var(--pixel24)', width: 'auto', cursor: 'pointer' }} />}
					label={language?.leaveTxt || 'Leave'}
				/>
			</Grid>
		</Grid>
	);
};

export default ControlPanel;
